import { simpleFetch } from './customFetch';

export const isLoggedIn = () => (
  fetch(process.env.REACT_APP_LOGIN_VERIFY_API, { credentials: 'include' })
);

export const getUserAccount = () => (
  simpleFetch(process.env.REACT_APP_ACCOUNT_API, {
    headers: {
      accept: 'application/vnd.fabfitfun.v2+json',
    },
  }, '')
);
